import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

import { PrivateHat } from 'src/layout/private-hat';
import { SubjectList } from 'src/features/feedback';
import { getTheme } from 'src/utils/get-theme';

export const FeedbackSubjectPage: FC = () => {
    const { t } = useTranslation();
    const { breakpoints } = useTheme();
    const { isHosTheme } = getTheme();

    return (
        <Fragment>
            <PrivateHat title={t('feedback_page_title')} backIconText={t('back_cta')} />

            <Stack padding={{ xs: '16px', md: '40px' }} alignItems={{ md: 'center' }}>
                <Typography
                    variant="body1"
                    color={isHosTheme ? 'text.primary' : 'text.secondary'}
                    aria-label="link text"
                    textAlign={{ md: 'center' }}
                    css={{
                        [breakpoints.up('md')]: {
                            maxWidth: '350px',
                        },
                    }}
                >
                    {t('feedback_page_description')}
                </Typography>

                <Typography
                    variant="h2"
                    color="text.primary"
                    marginTop={{ xs: '40px', md: '60px' }}
                >
                    {t('feedback_page_choose-a-topic')}
                </Typography>

                <SubjectList />
            </Stack>
        </Fragment>
    );
};
